/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsBillingPaymentCtrl
 */
angular.module('mercury.modules.settings.billing')
.controller('SettingsBillingPaymentCtrl', ["Payments", "$sce", "$scope", "$stateParams", "$timeout", "$window", function(Payments, $sce, $scope, $stateParams, $timeout, $window) {
  $scope.companyId = $stateParams.id;

  $scope.type = $stateParams.type == 1 ? 'Month' : 'Year';

  $window.paymentComplete = function(success, newExpiry) {
    // This needs to be wrapped in a timeout since it is called outside of Angularjs
    $timeout(function() {
      $scope.iFrameUrl = null;
      $scope.success = success;
      $scope.newExpiry = newExpiry;
    });
  };

  $scope.loading = Payments.getRequestUrl($stateParams.type, $stateParams.id);
  $scope.loading.then(function(response) {
    $scope.iFrameUrl = $sce.trustAsResourceUrl(response.data.uri);
  });
}]);
